export default {
	add_to_your_calendar: "Adicionar ao seu calendário",
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files: "Explore todo o nosso universo de cursos, vídeos, artigos e arquivos exclusivos.",
	home_drills_title: "Drills",
	home_events_title: "Meus Eventos",
	home_keep_watching_title: "Continue assistindo",
	home_library_title: "Biblioteca",
	home_live_classes_title: "Aulas ao Vivo",
	home_news_title: "Notícias",
	home_online_courses_title: "Cursos Online",
	home_podcasts_title: "Podcasts",
	home_surveys_title: "Pesquisas",
	home_tags_title: "Destaques",
	home_trails_title: "Trilhas",
	home_webinars_title: "Webinars",
	no_events_available_for_the_selected_date: "Não há eventos disponíveis.",
	welcome_to: "Bem-vindo(a) à",
	what_do_you_want_to_learn_today: "O que você deseja aprender hoje?"
}